<template>
  <!--닉네임-->
  <div class="contents-wrap">
    <p class="small semibold">
      {{ t('entrance_intro_message_2') }}
    </p>
    <input
      type="text"
      :class="['input-center', { 'input-error': isVisibleErrorNickname }]"
      :placeholder="t('input_nickname')"
      v-model="nicknameInput"
      maxlength="30"
      @focus="isVisibleErrorNickname = false"
      @keydown.enter="emit('pressed-enter')"
    />
    <div v-if="isVisibleErrorNickname" class="error-message">
      <InfoIcon class="icon-smaller icon-error" />
      <p class="small error">{{ t('error_input_no_nickname') }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import InfoIcon from '@/components/icons/IconInfo.vue';

const { t } = useI18n();

const emit = defineEmits<{
  'pressed-enter': [];
}>();

const nicknameInput = defineModel<string>('nicknameInput');
const isVisibleErrorNickname = defineModel<boolean>('isVisibleErrorNickname');
</script>

<style scoped lang="scss">
.contents-wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.25rem;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  white-space: nowrap;
}

.input-error {
  border: 1px solid;
  border-color: var(--error);
}

.error-message {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
}
</style>
